import React, { useEffect } from 'react'
import { DragDropContext } from '@hello-pangea/dnd'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'

import GoalOpenTasksMainSection from './GoalOpenTasksMainSection'
import OpenGoalTasksSuggestedSectionList from './OpenGoalTasksSuggestedSectionList'
import GoalOpenTasksMentionSection from './GoalOpenTasksMentionSection'
import GoalOpenTasksCalendarSection from './GoalOpenTasksCalendarSection'
import {
    CALENDAR_TASK_INDEX,
    DATE_TASK_INDEX,
    MAIN_TASK_INDEX,
    MENTION_TASK_INDEX,
    SUGGESTED_TASK_INDEX,
} from '../../../utils/backends/Tasks/openGoalTasks'
import { removeActiveDragTaskModeInDate, setSelectedTasks } from '../../../redux/actions'
import { taskMatchHashtagFilters } from '../../HashtagFilters/FilterHelpers/FilterTasks'

export default function GoalOpenTasksSections({ tasksData, projectId, dateIndex, goal }) {
    const dispatch = useDispatch()
    const activeDragTaskModeInDate = useSelector(state => state.activeDragTaskModeInDate)
    const hashtagFilters = useSelector(state => state.hashtagFilters) //NEEDED FOR FORCE A RENDER

    const dateFormated = tasksData[DATE_TASK_INDEX]
    const mainasksAmount = tasksData[MAIN_TASK_INDEX].length
    const mentionTasksAmount = tasksData[MENTION_TASK_INDEX].length
    const suggestedTasksSectionsAmount = tasksData[SUGGESTED_TASK_INDEX].length
    // Gate the section on what actually survives the hashtag filters, so an active filter that
    // excludes every meeting cannot leave an empty "Calendar" header behind.
    const calendarTasks = (tasksData[CALENDAR_TASK_INDEX] || []).filter(item => taskMatchHashtagFilters(item))

    const isActiveOrganizeMode =
        activeDragTaskModeInDate &&
        activeDragTaskModeInDate.projectId === projectId &&
        activeDragTaskModeInDate.dateIndex === dateIndex

    useEffect(() => {
        return () => {
            dispatch(removeActiveDragTaskModeInDate())
            dispatch(setSelectedTasks(null, true))
        }
    }, [])

    const isToday = dateFormated === moment().format('YYYYMMDD')

    return (
        <DragDropContext onDragEnd={() => {}} onBeforeCapture={() => {}}>
            {(isToday || mainasksAmount) > 0 && (
                <GoalOpenTasksMainSection
                    mainTasks={tasksData[MAIN_TASK_INDEX].filter(item => taskMatchHashtagFilters(item))}
                    projectId={projectId}
                    dateIndex={dateIndex}
                    isActiveOrganizeMode={isActiveOrganizeMode}
                    goal={goal}
                    dateFormated={dateFormated}
                />
            )}

            {mentionTasksAmount > 0 && (
                <GoalOpenTasksMentionSection
                    mentionTasks={tasksData[MENTION_TASK_INDEX].filter(item => taskMatchHashtagFilters(item))}
                    projectId={projectId}
                    dateIndex={dateIndex}
                    isActiveOrganizeMode={isActiveOrganizeMode}
                />
            )}
            {suggestedTasksSectionsAmount > 0 && (
                <OpenGoalTasksSuggestedSectionList
                    suggestedTasks={tasksData[SUGGESTED_TASK_INDEX].filter(item => taskMatchHashtagFilters(item))}
                    projectId={projectId}
                    dateIndex={dateIndex}
                    isActiveOrganizeMode={isActiveOrganizeMode}
                />
            )}
            {calendarTasks.length > 0 && (
                <GoalOpenTasksCalendarSection
                    calendarTasks={calendarTasks}
                    projectId={projectId}
                    dateIndex={dateIndex}
                    isActiveOrganizeMode={isActiveOrganizeMode}
                />
            )}
        </DragDropContext>
    )
}
